/* Vøggan hero: campaign slides move sideways when chosen from the dots, by a
   swipe on phones, or on a timer. The timer is the active dot's fill
   animation (CSS): when it ends the next slide comes in, and it pauses while
   the pointer or focus is inside the hero. With reduced motion there is no
   timer and slides change without moving. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DURATION = 600;

  // How far the hero starts from the top of the page (header, topbar), so
  // the CSS can keep the photo and category row within one screen.
  function measureTop(stage) {
    var hero = stage.closest('.vh');
    if (!hero) return;
    var top = hero.getBoundingClientRect().top + window.scrollY;
    hero.style.setProperty('--vh-top', Math.round(top) + 'px');
  }

  function init(stage) {
    if (stage.dataset.vhReady) return;
    stage.dataset.vhReady = '1';

    measureTop(stage);
    window.addEventListener('resize', function () { measureTop(stage); });

    var slides = Array.from(stage.querySelectorAll('[data-vh-slide]'));
    var dots = Array.from(stage.querySelectorAll('[data-vh-dot]'));
    if (slides.length < 2) return;

    var current = 0;
    var cleanup = null;

    function finish() {
      if (cleanup) cleanup();
    }

    function go(index, dir) {
      index = (index + slides.length) % slides.length;
      if (index === current) return;
      finish();

      var outgoing = slides[current];
      var incoming = slides[index];
      if (!dir) dir = index > current ? 1 : -1;
      current = index;
      stage.classList.add('has-moved');

      slides.forEach(function (s) {
        var on = s === incoming;
        s.classList.toggle('is-active', on);
        s.inert = !on;
        if (on) s.removeAttribute('aria-hidden');
        else s.setAttribute('aria-hidden', 'true');
      });
      dots.forEach(function (d, i) {
        var on = i === current;
        d.classList.toggle('is-active', on);
        if (on) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });

      if (reduceMotion) return;

      incoming.style.transform = 'translateX(calc(' + dir + ' * (100% + 1rem)))';
      outgoing.classList.add('is-leaving');
      void incoming.offsetWidth; // start the incoming slide off to the side

      incoming.classList.add('is-moving');
      outgoing.classList.add('is-moving');
      incoming.style.transform = 'translateX(0)';
      outgoing.style.transform = 'translateX(calc(' + -dir + ' * (100% + 1rem)))';

      var timer = setTimeout(finish, DURATION);
      cleanup = function () {
        clearTimeout(timer);
        cleanup = null;
        [incoming, outgoing].forEach(function (s) {
          s.classList.remove('is-moving', 'is-leaving');
          s.style.transform = '';
        });
      };
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        go(parseInt(d.getAttribute('data-vh-dot'), 10));
      });
    });

    // Autoplay: the active dot's fill has run out.
    stage.addEventListener('animationend', function (event) {
      if (event.animationName === 'vh-dot-fill') go(current + 1, 1);
    });

    function pause() { stage.classList.add('is-paused'); }
    function resume() { stage.classList.remove('is-paused'); }

    stage.addEventListener('pointerenter', function (event) {
      if (event.pointerType === 'mouse') pause();
    });
    stage.addEventListener('pointerleave', function (event) {
      if (event.pointerType === 'mouse') resume();
    });
    stage.addEventListener('focusin', pause);
    stage.addEventListener('focusout', function (event) {
      if (!stage.contains(event.relatedTarget)) resume();
    });

    // Swipe on touch screens; vertical scrolling is left alone.
    var startX = null;
    var startY = 0;
    stage.addEventListener('touchstart', function (event) {
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchend', function (event) {
      if (startX === null) return;
      var dx = event.changedTouches[0].clientX - startX;
      var dy = event.changedTouches[0].clientY - startY;
      startX = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
        go(current + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
      }
    }, { passive: true });

    // Theme editor: show the slide being edited and hold it there.
    document.addEventListener('shopify:block:select', function (event) {
      var i = slides.indexOf(event.target);
      if (i === -1) return;
      go(i);
      pause();
    });
    document.addEventListener('shopify:block:deselect', function (event) {
      if (slides.indexOf(event.target) !== -1) resume();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-vh]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
